import React, { FC } from 'react';

import BreadcrumbList, { PathItem } from 'Components/SeoSchema/BreadcrumbList';
import config from 'config/config';
import { TL4Category } from 'utils/graphql/categories';
import { TCity } from 'utils/graphql/geolocation';
import routes from 'utils/routeTranslator';

type BreadcrumbSchemaProps = {
  l4Category: TL4Category;
  city?: TCity;
};

export const l2Emojis: Record<string, string> = {
  'budowa-domu': '🏠',
  'remont': '🧱',
  'projektowanie': '📐',
  'meble-i-zabudowa': '🛌',
  'ogrod': '🌻',
  'malarz': '🧹',
  'hydraulik': '🚽',
  'elektryk': '⚡',
  'montaz-i-naprawa': '🛠️',
  'zlota-raczka': '👨‍🔧',
  'sprzatanie': '🧺',
  'uslugi-prawne-i-administracyjne': '💼',
  'organizacja-imprez': '🎉',
  'nie-kupuj': '♻️',
  'motoryzacja': '🚗',
  'szkolenia-i-jezyki-obce': '👨‍🏫',
  'transport': '🚚',
  'uslugi-dla-biznesu': '📈',
  'uslugi-finansowe': '💳',
  'zdrowie-i-uroda': '🧘',
};

export const getL2Emoji = (l2Slug: string): string => {
  const l2Emoji = l2Emojis[l2Slug];
  return l2Emoji ? `${l2Emoji} ` : '';
};

const BreadcrumbSchema: FC<BreadcrumbSchemaProps> = (props) => {
  const l2 = props.l4Category.l2;
  const l4 = props.l4Category;

  const items: PathItem[] = [
    {
      name: l2.name,
      url: `${config.SITE_URL}${routes.get('front::categories.type', { slug: l2.slug })}`,
    },
    {
      name: l4.name,
      url: `${config.SITE_URL}${routes.get('front::category', { slug: l4.slug })}`,
    },
  ];

  if (props.city) {
    const cityName = `${l4.name} ${props.city.nameLocativeCase || props.city.name}`;
    const route = routes.get('front::category', {
      slug: l4.slug,
      city: props.city.slug,
    });

    items.push({
      name: cityName,
      url: `${config.SITE_URL}${route}`,
    });
  }

  const lastItem = items[items.length - 1];
  lastItem.name = `${getL2Emoji(l2.slug)} ${lastItem.name}`;

  return <BreadcrumbList items={items} />;
};

export default BreadcrumbSchema;
